var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 15.1619C11.886 15.1619 11.7754 15.1427 11.6684 15.1042C11.5613 15.0657 11.461 14.9997 11.3674 14.9061L6.85781 10.3965C6.71295 10.2517 6.64308 10.0786 6.64821 9.8773C6.65333 9.67602 6.72833 9.50294 6.87321 9.35807C7.01808 9.21321 7.19371 9.14077 7.40011 9.14077C7.60651 9.14077 7.78215 9.21321 7.92701 9.35807L12.0001 13.4312L16.0886 9.3427C16.2335 9.19783 16.4065 9.12796 16.6078 9.13307C16.8091 9.13821 16.9821 9.21321 17.127 9.35807C17.2719 9.50294 17.3443 9.67858 17.3443 9.885C17.3443 10.0914 17.2719 10.267 17.127 10.4119L12.6328 14.9061C12.5392 14.9997 12.4405 15.0657 12.3366 15.1042C12.2328 15.1427 12.1206 15.1619 12.0001 15.1619Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.98f5f688524d16bbe0cb351a5d2effea.svg";
export { ForwardRef as ReactComponent };